"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComplexity = void 0;
const getNumberProperties_1 = require("./getNumberProperties");
/**
 * Returns the complexity of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns ComputedData
 */
function getComplexity(data) {
    const complexity = (0, getNumberProperties_1.getNumberProperties)(data, 'Complexity');
    return complexity;
}
exports.getComplexity = getComplexity;
//# sourceMappingURL=getComplexity.js.map